module.exports = __webpack_public_path__ + "img/PimpernellaUndRobot.206c7c21.svg";